import getByExerciseIdExerciseLogSummarySelector from '../get-by-exercise-id'
import { createSelector } from 'reselect'
import { EXERCISE_ID } from '../../../exercise/constants'

const getBarbellSquatExerciseLogSummarySelect = createSelector(
  getByExerciseIdExerciseLogSummarySelector(EXERCISE_ID.BARBELL_SQUAT),
  (instance) => instance
)

export default getBarbellSquatExerciseLogSummarySelect
